import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import API from "../config/axios";
import { api_paths } from "../config/api.paths";
import defaultAvatar from "../assets/images/contactus/defaultavatar.png";
import stars from "../assets/images/committee/Group 1321314203.png";
import call from "../assets/images/contactus/call.svg";
import mail from "../assets/images/contactus/mail.svg";
import LeftArrow from "../assets/images/committee/ArrowLeft.svg";
import { useNavigate } from "react-router-dom";
import { SET_LOADING } from "../redux/user";
import { useDispatch } from "react-redux";

const base_url = "https://preview.gujaratisamajtampabay.com:3071";

function CommitteeDetails() {
  const { id } = useParams();
  const [member, setMember] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const fetchCommitteeMember = async () => {
    try {
      dispatch(SET_LOADING(true));
      const response = await API.get(
        `${api_paths.committee.GET_COMMITTEE_MEMBER_DETAIL}/${id}`
      );

      const data = response?.data?.payload;
      setMember(data);
    } catch (error) {
      console.error("Error fetching member:", error);
    } finally {
      dispatch(SET_LOADING(false)); // STOP LOADING
    }
  };

  useEffect(() => {
    fetchCommitteeMember();
    //eslint-disable-next-line
  }, [id]);

  if (!member) return <p>Loading...</p>;

  return (
    <div className="committee-container">
      <img
        src={LeftArrow}
        alt="back-arrow"
        onClick={() => {
          navigate(-1);
        }}
      />

      <div className="committee-header">
        {/* LEFT SIDE IMAGE */}
        <img
          className="committee-photo"
          src={
            member.picture_path
              ? `${base_url}${member.picture_path}`
              : defaultAvatar
          }
          alt={member.name}
        />

        {/* RIGHT SIDE DETAILS */}
        <div className="committee-info">
          <h2 className="committee-name ">{member.name}</h2>

          <span className="committee-position">{member.position}</span>

          <div className="committee-details-list">
            {member.phone && (
              <p>
                {<img src={call} alt="call" />}{" "}
                <span className="m-4">{member.phone}</span>
              </p>
            )}

            {/* {member.email && ( */}
            <p>
              {<img src={mail} alt="mail" />}

              {/* <span>{member.email}</span> */}
              <span className="m-4">jinal.sutariya@gmail.com</span>
            </p>
            {/* )} */}

            {/* BIOGRAPHY SECTION */}
            <div className="committee-bio">
              <h3>Biography</h3>
              {/* <p>{member.biography}</p> */}
              <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since the 1500s, when an unknown printer took a galley
                of type and scrambled it to make a type specimen book.
              </p>
            </div>
          </div>
        </div>

        {/* DECORATION ICON RIGHT SIDE */}
        <div>
          <img src={stars} alt="icon" className="committee-stars" />
        </div>
      </div>
    </div>
  );
}

export default CommitteeDetails;
